import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { BsFillSendFill } from "react-icons/bs";
import { toast } from "react-toastify";
import { emailSchema } from "common/schema";
import { getApi, postApi } from "common/services/api";
import { getDataFromStorage } from "common/utils/storage";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import { globalStyles } from "common/theme/styles";

const AddEmailHistory = (props) => {
  const { onClose, isOpen, fetchData, setAction } = props;
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);

  const initialValues = {
    sender: user?._id,
    recipient: props.lead !== "true" ? props?.contactEmail : props?.leadEmail,
    subject: "",
    message: "",
    createBy: "",
    createByLead: "",
    startDate: "",
    endDate: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: emailSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);
      const outlook_access_token = getDataFromStorage(
        constant.outlookAccessToken
      );
      const updatedValue = outlook_access_token
        ? {
            outlook_access_token,
            ...values,
          }
        : {
            ...values,
          };
      let response = await postApi("api/email/add", updatedValue);
      if (response.status === 200) {
        if (props.setAction) props.setAction((pre) => !pre);
        toast.success(crmConstant.email_success);
        fetchData();
        console.log("====================================");
        console.log("came here");
        console.log("====================================");
      } else {
        toast.error(constant.something_went_wrong);
      }
    } catch (e) {
      toast.error(constant.something_went_wrong);
    } finally {
      setIsLoading(false);
      props.onClose();
      resetForm();
    }
  };

  const fetchRecipientData = () => {
    if (props.id && props.lead !== "true") {
      // let response = await getApi('api/contact/view/', props.id)
      // if (response?.status === 200) {
      // setFieldValue('recipient', props?.viewData?.contact?.email);
      setFieldValue("createBy", props.id);
      // values.recipient = props?.viewData?.contact?.email
      // }
    } else if (props.id && props.lead === "true") {
      // let response = await getApi('api/lead/view/', props.id)
      // if (response?.status === 200) {
      // setFieldValue('recipient', props?.viewData?.lead?.leadEmail);
      setFieldValue("createByLead", props.id);
      // values.recipient = props?.viewData?.lead?.leadEmail
      // }
    }
  };
  useEffect(() => {
    fetchRecipientData();
  }, [props.id, props.lead]);

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent maxWidth={"700px"}>
        <ModalHeader>{constant.sendEmail}</ModalHeader>
        <IconButton
          size="xs"
          className="closeIcon"
          onClick={() => {
            formik.resetForm();
            onClose();
          }}
          icon={<CloseIcon />}
        />

        <ModalBody className="modalBody">
          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.recipent}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.recipient}
                name="recipient"
                disabled
                placeholder="Recipient"
                fontWeight="500"
                borderColor={
                  errors.recipient && touched.recipient ? "red.300" : null
                }
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.recipient && touched.recipient && errors.recipient}
              </Text>
            </GridItem>
            
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.dateAndTime}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.startDate}
                name="startDate"
                fontWeight="500"
                borderColor={
                  errors?.startDate && touched?.startDate ? "red.300" : null
                }
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.startDate && touched.startDate && errors.startDate}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.subject}
              </FormLabel>
              <Input
                fontSize="sm"
                placeholder="Enter subject"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.subject}
                name="subject"
                fontWeight="500"
                borderColor={
                  errors.subject && touched.subject ? "red.300" : null
                }
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.subject && touched.subject && errors.subject}
              </Text>
            </GridItem>
            {/* <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.endDate}
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                min={values.startDate}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.endDate}
                name="endDate"
                fontWeight="500"
                borderColor={
                  errors?.endDate && touched?.endDate ? "red.300" : null
                }
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.endDate && touched.endDate && errors.endDate}
              </Text>
            </GridItem> */}
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.message}
              </FormLabel>
              <Textarea
                fontSize="sm"
                placeholder="Type message here"
                resize={"none"}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.message}
                name="message"
                fontWeight="500"
                borderColor={
                  errors.message && touched.message
                    ? "red.300"
                    : touched.message
                }
              />
              <Text fontSize="sm" mb="10px" color={"red"}>
                {" "}
                {errors.message && touched.message && errors.message}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            className="theme-btn2 cancelBtn"
            size="sm"
            onClick={() => {
              formik.resetForm();
              onClose();
            }}
          >
            Close
          </Button>

          <Button
            className="theme-btn1"
            size="sm"
            variant="brand"
            onClick={handleSubmit}
            disabled={isLoading ? true : false}
          >
            {isLoading ? (
              <Spinner
                size={20}
                paddingRight={5}
                border={`3px solid ${globalStyles.colors.loaderBorder}`}
                borderTop={`1px solid ${globalStyles.colors.transparent}`}
              />
            ) : (
              ""
            )}{" "}
            {constant.send}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddEmailHistory;
